import { UpdateCourseFromEntityUseCaseInterface } from 'domain/usecases';
import { notifyError, notifySuccess } from 'presentation/app/components/notify';
import { useService } from 'presentation/app/hooks/useService';
import { ChangeEvent, useCallback, useRef, useState } from 'react';
import { Input } from 'reactstrap';

interface IProps {
  relationshipId: number;
  apiCode: string | null;
}

export const CourseApiCodeInput = ({ relationshipId, apiCode }: IProps) => {
  // Hooks
  const { entitiesService } = useService();

  // States
  const [apiCodeInputCurrentValue, setApiCodeInputCurrentValue] = useState(
    apiCode || '',
  );
  const apiCodeInputOldValue = useRef(apiCode || '');

  // Methods
  const requestUpdateCourseFromEntity = useCallback(
    async (params: UpdateCourseFromEntityUseCaseInterface.Params) => {
      await entitiesService
        .updateCourseFromEntity(params)
        .then((res) => {
          apiCodeInputOldValue.current = params.apiCode;
          notifySuccess(res.message);
        })
        .catch((err) => {
          setApiCodeInputCurrentValue(apiCodeInputOldValue.current);
          notifyError(err.message);
        });
    },
    [apiCodeInputOldValue.current],
  );

  const handleApiCodeInputChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setApiCodeInputCurrentValue(e.target.value);
    },
    [],
  );

  const handleApiCodeInputBlur = useCallback(
    (e: React.FocusEvent<HTMLInputElement>) => {
      if (e.target?.value !== apiCodeInputOldValue.current) {
        requestUpdateCourseFromEntity({
          id: relationshipId,
          apiCode: e.target?.value,
        });
      }
    },
    [
      relationshipId,
      apiCodeInputCurrentValue,
      apiCodeInputOldValue.current,
      requestUpdateCourseFromEntity,
    ],
  );

  const handleApiCodeInputKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter') {
        requestUpdateCourseFromEntity({
          id: relationshipId,
          apiCode: e.currentTarget?.value,
        });
      }
    },
    [
      relationshipId,
      apiCodeInputCurrentValue,
      apiCodeInputOldValue.current,
      requestUpdateCourseFromEntity,
    ],
  );

  return (
    <Input
      type="text"
      id="apiCode"
      name="apiCode"
      value={apiCodeInputCurrentValue}
      onChange={handleApiCodeInputChange}
      onBlur={handleApiCodeInputBlur}
      onKeyDown={handleApiCodeInputKeyDown}
      placeholder="Código de Integração API"
      style={{ width: '50%' }}
    />
  );
};
